import { Typography } from "@mui/material";
import { pluralize } from "~/lib/pluralize";
import { FormatDate } from "~/lib/date";
import { LockClosedIcon } from "~/icons";

type HeaderTagsProps = {
  totalAssets: number;
  closedAt?: string | undefined;
};

export const TicketHeaderTags = ({
  totalAssets,
  closedAt,
}: HeaderTagsProps) => {
  return (
    <>
      {closedAt && (
        <Typography
          id="created-by"
          variant="caption"
          color="text.secondary"
          fontWeight={700}
          sx={{ mx: 3, display: "inline-flex", alignItems: "center" }}
        >
          <LockClosedIcon
            fontSize="inherit"
            sx={{ mr: 0.5, color: (theme) => theme.palette.text.secondary }}
          />
          Closed {FormatDate(closedAt)}
        </Typography>
      )}

      <Typography
        id="assets"
        variant="caption"
        color="text.secondary"
        fontWeight={700}
        sx={{ mx: 3, display: "inline-flex", alignItems: "center" }}
      >
        {pluralize("Asset", totalAssets)} {totalAssets}
      </Typography>
    </>
  );
};
